import { makeStyles } from "@mui/styles";
import Lottie from "lottie-react";
import LtpctLoader from "../../Asset/Ltpct.json";

const useStyles = makeStyles(() => ({
  root: {
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: "rgba(0,0,0,0.3)",
    zIndex: 99999,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loaderContainer: {
    background: "#fff",
    borderRadius: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  },
}));

export default function KenLoader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.loaderContainer}>
        <Lottie animationData={LtpctLoader} style={{ width: 200, height: 200 }} />
      </div>
    </div>
  );
}
